import React from 'react';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const About = () => {
  const location = useLocation()

  useEffect(()=>{
    const html = document.getElementsByTagName('html')[0];
    html.setAttribute('data-wf-page', '68603f7a056ff6f78f58cb54');
    html.setAttribute('data-wf-site', '68603f7a056ff6f78f58cab1');
    window.Webflow && window.Webflow.destroy();
    window.Webflow && window.Webflow.ready();
    window.Webflow && window.Webflow.require('ix2').init();
    document.dispatchEvent(new Event('readystatechange'))
  },[])

  return (
    <>
      <div className="page-wrapper" data-w-id="67e8c68d888006cd08bbc8ce" style={{"opacity":"0"}}>
        <Navbar />
        <section className="section inner-banner">
          <div className="inner-banner-content">
            <div className="inner-banner-wrapper">
              <div className="container">
                <div className="inner-banner-typography">
                  <div className="inner-banner-subtitle-wrap">
                    <div className="inner-banner-subtitle">About us</div>
                  </div>
                  <div className="inner-banner-title-wrapper">
                    <h1 className="inner-banner-title about-us">Solutions for seamless web3 &amp; blockchain experience.</h1>
                    <p className="inner-banner-description about-us">Empower your business with AI-driven insights and
                      predictive analytics for scale faster by centralising.</p>
                  </div>
                </div>
              </div><img src="images/inner-20banner-20pluse-20icon.svg" loading="lazy" alt=""
                className="inner-banner-pluse-icon top-left" /><img src="images/inner-20banner-20pluse-20icon.svg"
                  loading="lazy" alt="" className="inner-banner-pluse-icon top-right" /><img
                src="images/inner-20banner-20pluse-20icon.svg" loading="lazy" alt=""
                className="inner-banner-pluse-icon bottom-left" /><img src="images/inner-20banner-20pluse-20icon.svg"
                  loading="lazy" alt="" className="inner-banner-pluse-icon bottom-right" />
            </div>
          </div>
        </section>
        <section className="section about-us-gallery">
          <div className="about-us-gallery-container">
            <div data-w-id="b5b2be2c-67e6-7ba9-6d32-f33422506a58" style={{ "opacity": "0" }} className="about-us-gallery-wrapper">
              <div className="about-us-gallery-image-wrapper"><img src="images/about-20us-20gallery-20image1.webp"
                loading="lazy" alt="" className="about-us-gallery-image left" /><img
                  src="images/about-20us-20gallery-20image2.webp" loading="lazy" sizes="(max-width: 840px) 100vw, 840px"
                  srcset="images/about-20us-20gallery-20image2.webp 500w, images/about-20us-20gallery-20image2.webp 800w, images/about-20us-20gallery-20image2.webp 840w"
                  alt="" className="about-us-gallery-image middle" /><img src="images/about-20us-20gallery-20image3.webp"
                    loading="lazy" alt="" className="about-us-gallery-image right" /></div>
              <div className="about-us-gallery-description-wrapper">
                <p className="about-us-gallery-description-text">We create data-driven experiences that are both aesthetically
                  pleasing and functionally frictionless. We always build with the intent to serve the customer while
                  meeting our client&#x27;s needs.</p>
              </div>
            </div>
          </div>
        </section>
        <div data-w-id="443ba8b5-9339-7af4-f25e-0ea568c43a63" className="partner-ticker-wrapper">
          <div className="partner-ticker-item">
            <div className="partners-logo-grid-wrap">
              <div className="single-partner-logo-wrap blank"></div>
              <div className="single-partner-logo-wrap blank"></div>
              <div className="single-partner-logo-wrap bg-black"><img loading="lazy" src="images/partner-logo-4.svg" alt=""
                className="partner-logo" /></div>
              <div className="single-partner-logo-wrap blank"></div>
              <div className="single-partner-logo-wrap blank"></div>
              <div className="single-partner-logo-wrap blank"></div>
              <div className="single-partner-logo-wrap blank"></div>
              <div className="single-partner-logo-wrap blank"></div>
              <div className="single-partner-logo-wrap blank"></div>
              <div className="single-partner-logo-wrap bordered"><img loading="lazy" src="images/partner-20logo2.svg" alt=""
                className="partner-logo" /></div>
              <div className="single-partner-logo-wrap blank"></div>
              <div className="single-partner-logo-wrap bordered"><img loading="lazy" src="images/partner-20logo3.svg" alt=""
                className="partner-logo" /></div>
              <div className="single-partner-logo-wrap blank"></div>
              <div className="single-partner-logo-wrap bg-black"><img loading="lazy" src="images/partner-20logo4.svg" alt=""
                className="partner-logo" /></div>
              <div className="single-partner-logo-wrap blank"></div>
              <div id="w-node-_443ba8b5-9339-7af4-f25e-0ea568c43a79-8f58cb54" className="single-partner-logo-wrap bordered"><img
                loading="lazy" src="images/partner-20logo5.svg" alt="" className="partner-logo" /></div>
              <div className="single-partner-logo-wrap bg-black"><img loading="lazy" src="images/partner-20logo5.svg" alt=""
                className="partner-logo" /></div>
              <div className="single-partner-logo-wrap blank"></div>
              <div id="w-node-_443ba8b5-9339-7af4-f25e-0ea568c43a7e-8f58cb54" className="single-partner-logo-wrap bg-black"><img
                loading="lazy" src="images/partner-20logo6.svg" alt="" className="partner-logo" /></div>
              <div className="single-partner-logo-wrap blank"></div>
              <div className="single-partner-logo-wrap bordered"><img loading="lazy" src="images/partner-20logo7.svg" alt=""
                className="partner-logo" /></div>
              <div className="single-partner-logo-wrap blank"></div>
              <div className="single-partner-logo-wrap bg-black"><img loading="lazy" src="images/partner-logo-7.svg" alt=""
                className="partner-logo" /></div>
              <div className="single-partner-logo-wrap blank"></div>
              <div className="single-partner-logo-wrap blank"></div>
              <div className="single-partner-logo-wrap bordered"><img loading="lazy" src="images/partner-20logo4.svg" alt=""
                className="partner-logo" /></div>
              <div className="single-partner-logo-wrap blank"></div>
              <div id="w-node-_443ba8b5-9339-7af4-f25e-0ea568c43a8b-8f58cb54" className="single-partner-logo-wrap bg-black"><img
                loading="lazy" src="images/partner-20logo1.svg" alt="" className="partner-logo" /></div>
              <div className="single-partner-logo-wrap blank"></div>
              <div className="single-partner-logo-wrap bordered"><img loading="lazy" src="images/partner-20logo2.svg" alt=""
                className="partner-logo" /></div>
              <div className="single-partner-logo-wrap blank"></div>
              <div className="single-partner-logo-wrap blank"></div>
            </div>
          </div>
          <div className="partner-ticker-item">
            <div className="partners-logo-grid-wrap">
              <div className="single-partner-logo-wrap blank"></div>
              <div className="single-partner-logo-wrap blank"></div>
              <div className="single-partner-logo-wrap bg-black"><img loading="lazy" src="images/partner-logo-4.svg" alt=""
                className="partner-logo" /></div>
              <div className="single-partner-logo-wrap blank"></div>
              <div className="single-partner-logo-wrap blank"></div>
              <div className="single-partner-logo-wrap blank"></div>
              <div className="single-partner-logo-wrap blank"></div>
              <div className="single-partner-logo-wrap blank"></div>
              <div className="single-partner-logo-wrap blank"></div>
              <div className="single-partner-logo-wrap bordered"><img loading="lazy" src="images/partner-20logo2.svg" alt=""
                className="partner-logo" /></div>
              <div className="single-partner-logo-wrap blank"></div>
              <div className="single-partner-logo-wrap bordered"><img loading="lazy" src="images/partner-20logo3.svg" alt=""
                className="partner-logo" /></div>
              <div className="single-partner-logo-wrap blank"></div>
              <div className="single-partner-logo-wrap bg-black"><img loading="lazy" src="images/partner-20logo4.svg" alt=""
                className="partner-logo" /></div>
              <div className="single-partner-logo-wrap blank"></div>
              <div id="w-node-c6ec9b89-9b17-1eca-d77b-c3f3653b0199-8f58cb54" className="single-partner-logo-wrap bordered"><img
                loading="lazy" src="images/partner-20logo5.svg" alt="" className="partner-logo" /></div>
              <div className="single-partner-logo-wrap bg-black"><img loading="lazy" src="images/partner-20logo5.svg" alt=""
                className="partner-logo" /></div>
              <div className="single-partner-logo-wrap blank"></div>
              <div id="w-node-c6ec9b89-9b17-1eca-d77b-c3f3653b019e-8f58cb54" className="single-partner-logo-wrap bg-black"><img
                loading="lazy" src="images/partner-20logo6.svg" alt="" className="partner-logo" /></div>
              <div className="single-partner-logo-wrap blank"></div>
              <div className="single-partner-logo-wrap bordered"><img loading="lazy" src="images/partner-20logo7.svg" alt=""
                className="partner-logo" /></div>
              <div className="single-partner-logo-wrap blank"></div>
              <div className="single-partner-logo-wrap bg-black"><img loading="lazy" src="images/partner-logo-7.svg" alt=""
                className="partner-logo" /></div>
              <div className="single-partner-logo-wrap blank"></div>
              <div className="single-partner-logo-wrap blank"></div>
              <div className="single-partner-logo-wrap bordered"><img loading="lazy" src="images/partner-20logo4.svg" alt=""
                className="partner-logo" /></div>
              <div className="single-partner-logo-wrap blank"></div>
              <div id="w-node-c6ec9b89-9b17-1eca-d77b-c3f3653b01ab-8f58cb54" className="single-partner-logo-wrap bg-black"><img
                loading="lazy" src="images/partner-20logo1.svg" alt="" className="partner-logo" /></div>
              <div className="single-partner-logo-wrap blank"></div>
              <div className="single-partner-logo-wrap bordered"><img loading="lazy" src="images/partner-20logo2.svg" alt=""
                className="partner-logo" /></div>
              <div className="single-partner-logo-wrap blank"></div>
              <div className="single-partner-logo-wrap blank"></div>
            </div>
          </div>
          <div className="partner-ticker-item">
            <div className="partners-logo-grid-wrap">
              <div className="single-partner-logo-wrap blank"></div>
              <div className="single-partner-logo-wrap blank"></div>
              <div className="single-partner-logo-wrap bg-black"><img loading="lazy" src="images/partner-logo-4.svg" alt=""
                className="partner-logo" /></div>
              <div className="single-partner-logo-wrap blank"></div>
              <div className="single-partner-logo-wrap blank"></div>
              <div className="single-partner-logo-wrap blank"></div>
              <div className="single-partner-logo-wrap blank"></div>
              <div className="single-partner-logo-wrap blank"></div>
              <div className="single-partner-logo-wrap blank"></div>
              <div className="single-partner-logo-wrap bordered"><img loading="lazy" src="images/partner-20logo2.svg" alt=""
                className="partner-logo" /></div>
              <div className="single-partner-logo-wrap blank"></div>
              <div className="single-partner-logo-wrap bordered"><img loading="lazy" src="images/partner-20logo3.svg" alt=""
                className="partner-logo" /></div>
              <div className="single-partner-logo-wrap blank"></div>
              <div className="single-partner-logo-wrap bg-black"><img loading="lazy" src="images/partner-20logo4.svg" alt=""
                className="partner-logo" /></div>
              <div className="single-partner-logo-wrap blank"></div>
              <div id="w-node-a5d56700-1f8c-0388-d064-438cf49d417c-8f58cb54" className="single-partner-logo-wrap bordered"><img
                loading="lazy" src="images/partner-20logo5.svg" alt="" className="partner-logo" /></div>
              <div className="single-partner-logo-wrap bg-black"><img loading="lazy" src="images/partner-20logo5.svg" alt=""
                className="partner-logo" /></div>
              <div className="single-partner-logo-wrap blank"></div>
              <div id="w-node-a5d56700-1f8c-0388-d064-438cf49d4181-8f58cb54" className="single-partner-logo-wrap bg-black"><img
                loading="lazy" src="images/partner-20logo6.svg" alt="" className="partner-logo" /></div>
              <div className="single-partner-logo-wrap blank"></div>
              <div className="single-partner-logo-wrap bordered"><img loading="lazy" src="images/partner-20logo7.svg" alt=""
                className="partner-logo" /></div>
              <div className="single-partner-logo-wrap blank"></div>
              <div className="single-partner-logo-wrap bg-black"><img loading="lazy" src="images/partner-logo-7.svg" alt=""
                className="partner-logo" /></div>
              <div className="single-partner-logo-wrap blank"></div>
              <div className="single-partner-logo-wrap blank"></div>
              <div className="single-partner-logo-wrap bordered"><img loading="lazy" src="images/partner-20logo4.svg" alt=""
                className="partner-logo" /></div>
              <div className="single-partner-logo-wrap blank"></div>
              <div id="w-node-a5d56700-1f8c-0388-d064-438cf49d418e-8f58cb54" className="single-partner-logo-wrap bg-black"><img
                loading="lazy" src="images/partner-20logo1.svg" alt="" className="partner-logo" /></div>
              <div className="single-partner-logo-wrap blank"></div>
              <div className="single-partner-logo-wrap bordered"><img loading="lazy" src="images/partner-20logo2.svg" alt=""
                className="partner-logo" /></div>
              <div className="single-partner-logo-wrap blank"></div>
              <div className="single-partner-logo-wrap blank"></div>
            </div>
          </div>
        </div>
        <section className="section speaks-section">
          <div className="container">
            <div data-w-id="c2a5b41a-c05b-4412-69f6-6a7c793dad66" style={{ "opacity": "0" }} className="speaks-content">
              <div className="review-wrapper">
                <div className="speaks-section-title-wrapper">
                  <h3 className="speaks-section-title">...Records also speaks for Itself.</h3>
                </div>
                <div className="review-contant-wrap">
                  <div className="review-contant">
                    <div className="review-flex-wrap">
                      <div className="review-2-column-grid">
                        <div className="review-info-wrap">
                          <div className="review-info-flex-wrap">
                            <div data-w-id="d0ac3e16-b8b6-c2ff-d2ec-11d09c4ff35d" className="history-counter-wrap hight-80px">
                              <h3 className="number-digit font-80px">$</h3>
                              <div
                                style={{ WebkitTransform: "translate3d(0, 0%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)", "-moz-transform": "translate3d(0, 0%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)", msTransform: "translate3d(0, 0%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)", "transform": "translate3d(0, 0%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)" }}
                                className="single-counter-wrap _1">
                                <h3 className="number-digit font-80px">0</h3>
                                <h3 className="number-digit font-80px">1</h3>
                                <h3 className="number-digit font-80px">2</h3>
                                <h3 className="number-digit font-80px">3</h3>
                                <h3 className="number-digit font-80px">4</h3>
                                <h3 className="number-digit font-80px">5</h3>
                                <h3 className="number-digit font-80px">6</h3>
                                <h3 className="number-digit font-80px">1</h3>
                                <h3 className="number-digit font-80px">8</h3>
                                <h3 className="number-digit font-80px">9</h3>
                              </div>
                              <div
                                style={{ WebkitTransform: "translate3d(0, 0%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)", "-moz-transform": "translate3d(0, 0%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)", msTransform: "translate3d(0, 0%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)", "transform": "translate3d(0, 0%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)" }}
                                className="single-counter-wrap _2">
                                <h3 className="number-digit font-80px">9</h3>
                                <h3 className="number-digit font-80px">8</h3>
                                <h3 className="number-digit font-80px">7</h3>
                                <h3 className="number-digit font-80px">2</h3>
                                <h3 className="number-digit font-80px">5</h3>
                                <h3 className="number-digit font-80px">4</h3>
                                <h3 className="number-digit font-80px">3</h3>
                                <h3 className="number-digit font-80px">2</h3>
                                <h3 className="number-digit font-80px">1</h3>
                                <h3 className="number-digit font-80px">0</h3>
                              </div>
                              <div
                                style={{ WebkitTransform: "translate3d(0, 0%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)", "-moz-transform": "translate3d(0, 0%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)", msTransform: "translate3d(0, 0%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)", "transform": "translate3d(0, 0%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)" }}
                                className="single-counter-wrap _1">
                                <h3 className="number-digit font-80px">0</h3>
                                <h3 className="number-digit font-80px">1</h3>
                                <h3 className="number-digit font-80px">2</h3>
                                <h3 className="number-digit font-80px">3</h3>
                                <h3 className="number-digit font-80px">4</h3>
                                <h3 className="number-digit font-80px">5</h3>
                                <h3 className="number-digit font-80px">6</h3>
                                <h3 className="number-digit font-80px">0</h3>
                                <h3 className="number-digit font-80px">8</h3>
                                <h3 className="number-digit font-80px">9</h3>
                              </div>
                              <h3 className="number-digit font-80px">.00</h3>
                              <h3 className="number-digit font-80px">M</h3>
                              <h3 className="number-digit font-80px">+</h3>
                            </div>
                            <div className="review-info-total-text">total productivity in all over the world</div>
                          </div>
                        </div>
                        <div className="single-review-info-wrap">
                          <div className="single-about-info-content-wrap">
                            <h4 className="about-info-title">clients satisfaction</h4>
                            <div data-w-id="d0ac3e16-b8b6-c2ff-d2ec-11d09c4ff3a9" className="history-counter-wrap">
                              <div
                                style={{ WebkitTransform: "translate3d(0, 0%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)", "-moz-transform": "translate3d(0, 0%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)", msTransform: "translate3d(0, 0%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)", "transform": "translate3d(0, 0%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)" }}
                                className="single-counter-wrap _1">
                                <h3 className="number-digit">0</h3>
                                <h3 className="number-digit">1</h3>
                                <h3 className="number-digit">2</h3>
                                <h3 className="number-digit">3</h3>
                                <h3 className="number-digit">4</h3>
                                <h3 className="number-digit">5</h3>
                                <h3 className="number-digit">6</h3>
                                <h3 className="number-digit">9</h3>
                                <h3 className="number-digit">8</h3>
                                <h3 className="number-digit">9</h3>
                              </div>
                              <div
                                style={{ WebkitTransform: "translate3d(0, 0%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)", "-moz-transform": "translate3d(0, 0%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)", msTransform: "translate3d(0, 0%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)", "transform": "translate3d(0, 0%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)" }}
                                className="single-counter-wrap _2">
                                <h3 className="number-digit">9</h3>
                                <h3 className="number-digit">8</h3>
                                <h3 className="number-digit">7</h3>
                                <h3 className="number-digit">9</h3>
                                <h3 className="number-digit">5</h3>
                                <h3 className="number-digit">4</h3>
                                <h3 className="number-digit">3</h3>
                                <h3 className="number-digit">2</h3>
                                <h3 className="number-digit">1</h3>
                                <h3 className="number-digit">0</h3>
                              </div>
                              <h3 className="number-digit">%</h3>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="review-3-column-grid">
                        <div className="single-review-info-wrap">
                          <div className="single-about-info-content-wrap">
                            <h4 className="about-info-title">satisfied customers</h4>
                            <div data-w-id="d0ac3e16-b8b6-c2ff-d2ec-11d09c4ff3db" className="history-counter-wrap">
                              <div
                                style={{ WebkitTransform: "translate3d(0, 0%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)", "-moz-transform": "translate3d(0, 0%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)", msTransform: "translate3d(0, 0%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)", "transform": "translate3d(0, 0%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)" }}
                                className="single-counter-wrap _1">
                                <h3 className="number-digit">0</h3>
                                <h3 className="number-digit">1</h3>
                                <h3 className="number-digit">2</h3>
                                <h3 className="number-digit">3</h3>
                                <h3 className="number-digit">4</h3>
                                <h3 className="number-digit">5</h3>
                                <h3 className="number-digit">6</h3>
                                <h3 className="number-digit">1</h3>
                                <h3 className="number-digit">8</h3>
                                <h3 className="number-digit">9</h3>
                              </div>
                              <div
                                style={{ WebkitTransform: "translate3d(0, 0%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)", "-moz-transform": "translate3d(0, 0%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)", msTransform: "translate3d(0, 0%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)", "transform": "translate3d(0, 0%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)" }}
                                className="single-counter-wrap _2">
                                <h3 className="number-digit">9</h3>
                                <h3 className="number-digit">8</h3>
                                <h3 className="number-digit">7</h3>
                                <h3 className="number-digit">2</h3>
                                <h3 className="number-digit">5</h3>
                                <h3 className="number-digit">4</h3>
                                <h3 className="number-digit">3</h3>
                                <h3 className="number-digit">2</h3>
                                <h3 className="number-digit">1</h3>
                                <h3 className="number-digit">0</h3>
                              </div>
                              <div
                                style={{ WebkitTransform: "translate3d(0, 0%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)", "-moz-transform": "translate3d(0, 0%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)", msTransform: "translate3d(0, 0%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)", "transform": "translate3d(0, 0%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)" }}
                                className="single-counter-wrap _1">
                                <h3 className="number-digit">0</h3>
                                <h3 className="number-digit">1</h3>
                                <h3 className="number-digit">2</h3>
                                <h3 className="number-digit">3</h3>
                                <h3 className="number-digit">4</h3>
                                <h3 className="number-digit">5</h3>
                                <h3 className="number-digit">6</h3>
                                <h3 className="number-digit">0</h3>
                                <h3 className="number-digit">8</h3>
                                <h3 className="number-digit">9</h3>
                              </div>
                              <h3 className="number-digit">K</h3>
                              <h3 className="number-digit">+</h3>
                            </div>
                          </div>
                        </div>
                        <div className="single-review-info-wrap">
                          <div className="single-about-info-content-wrap">
                            <h4 className="about-info-title">Project completed</h4>
                            <div data-w-id="d0ac3e16-b8b6-c2ff-d2ec-11d09c4ff423" className="history-counter-wrap">
                              <div
                                style={{ WebkitTransform: "translate3d(0, 0%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)", "-moz-transform": "translate3d(0, 0%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)", msTransform: "translate3d(0, 0%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)", "transform": "translate3d(0, 0%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)" }}
                                className="single-counter-wrap _1">
                                <h3 className="number-digit">0</h3>
                                <h3 className="number-digit">1</h3>
                                <h3 className="number-digit">2</h3>
                                <h3 className="number-digit">3</h3>
                                <h3 className="number-digit">4</h3>
                                <h3 className="number-digit">5</h3>
                                <h3 className="number-digit">6</h3>
                                <h3 className="number-digit">0</h3>
                                <h3 className="number-digit">8</h3>
                                <h3 className="number-digit">9</h3>
                              </div>
                              <div
                                style={{ WebkitTransform: "translate3d(0, 0%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)", "-moz-transform": "translate3d(0, 0%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)", msTransform: "translate3d(0, 0%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)", "transform": "translate3d(0, 0%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)" }}
                                className="single-counter-wrap _2">
                                <h3 className="number-digit">9</h3>
                                <h3 className="number-digit">8</h3>
                                <h3 className="number-digit">7</h3>
                                <h3 className="number-digit">1</h3>
                                <h3 className="number-digit">5</h3>
                                <h3 className="number-digit">4</h3>
                                <h3 className="number-digit">3</h3>
                                <h3 className="number-digit">2</h3>
                                <h3 className="number-digit">1</h3>
                                <h3 className="number-digit">0</h3>
                              </div>
                              <h3 className="number-digit">M</h3>
                              <h3 className="number-digit">+</h3>
                            </div>
                          </div>
                        </div>
                        <div className="single-review-info-wrap">
                          <div className="single-about-info-content-wrap">
                            <h4 className="about-info-title">Here since</h4>
                            <div data-w-id="d0ac3e16-b8b6-c2ff-d2ec-11d09c4ff456" className="history-counter-wrap">
                              <div
                                style={{ WebkitTransform: "translate3d(0, 0%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)", "-moz-transform": "translate3d(0, 0%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)", msTransform: "translate3d(0, 0%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)", "transform": "translate3d(0, 0%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)" }}
                                className="single-counter-wrap _1">
                                <h3 className="number-digit">0</h3>
                                <h3 className="number-digit">1</h3>
                                <h3 className="number-digit">2</h3>
                                <h3 className="number-digit">3</h3>
                                <h3 className="number-digit">4</h3>
                                <h3 className="number-digit">5</h3>
                                <h3 className="number-digit">6</h3>
                                <h3 className="number-digit">2</h3>
                                <h3 className="number-digit">8</h3>
                                <h3 className="number-digit">9</h3>
                              </div>
                              <div
                                style={{ WebkitTransform: "translate3d(0, 0%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)", "-moz-transform": "translate3d(0, 0%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)", msTransform: "translate3d(0, 0%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)", "transform": "translate3d(0, 0%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)" }}
                                className="single-counter-wrap _2">
                                <h3 className="number-digit">9</h3>
                                <h3 className="number-digit">8</h3>
                                <h3 className="number-digit">7</h3>
                                <h3 className="number-digit">0</h3>
                                <h3 className="number-digit">5</h3>
                                <h3 className="number-digit">4</h3>
                                <h3 className="number-digit">3</h3>
                                <h3 className="number-digit">2</h3>
                                <h3 className="number-digit">1</h3>
                                <h3 className="number-digit">0</h3>
                              </div>
                              <div
                                style={{ WebkitTransform: "translate3d(0, 0%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)", "-moz-transform": "translate3d(0, 0%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)", msTransform: "translate3d(0, 0%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)", "transform": "translate3d(0, 0%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)" }}
                                className="single-counter-wrap _1">
                                <h3 className="number-digit">0</h3>
                                <h3 className="number-digit">1</h3>
                                <h3 className="number-digit">2</h3>
                                <h3 className="number-digit">3</h3>
                                <h3 className="number-digit">4</h3>
                                <h3 className="number-digit">5</h3>
                                <h3 className="number-digit">6</h3>
                                <h3 className="number-digit">2</h3>
                                <h3 className="number-digit">8</h3>
                                <h3 className="number-digit">9</h3>
                              </div>
                              <div
                                style={{ WebkitTransform: "translate3d(0, 0%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)", "-moz-transform": "translate3d(0, 0%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)", msTransform: "translate3d(0, 0%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)", "transform": "translate3d(0, 0%, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)" }}
                                className="single-counter-wrap _2">
                                <h3 className="number-digit">9</h3>
                                <h3 className="number-digit">8</h3>
                                <h3 className="number-digit">7</h3>
                                <h3 className="number-digit">4</h3>
                                <h3 className="number-digit">5</h3>
                                <h3 className="number-digit">4</h3>
                                <h3 className="number-digit">3</h3>
                                <h3 className="number-digit">2</h3>
                                <h3 className="number-digit">1</h3>
                                <h3 className="number-digit">0</h3>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="line-wrap-two">
                      <div className="single-line-wrap _1 cta">
                        <div className="line"></div>
                        <div className="line _2"></div>
                      </div>
                      <div className="single-line-wrap _2 cta">
                        <div className="line _3"></div>
                        <div className="line _4"></div>
                      </div>
                      <div className="single-line-wrap _3 cta">
                        <div className="line _5"></div>
                        <div className="line _6"></div>
                      </div>
                      <div className="single-line-wrap _4 inner">
                        <div className="line _7"></div>
                        <div className="line _8"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="section community-spotlight">
          <div data-w-id="7436af0c-4104-52c0-12c7-24cd299651a4" className="community-spotlight-content">
            <div className="community-spotlight-typography">
              <div className="community-spotlight-icon-wrapper"><img src="/images/community-20spotlight-20icon.webp"
                loading="lazy"
                style={{ WebkitTransform: "translate3d(0, 0, 0) scale3d(0.6, 0.6, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);-moz-transform:translate3d(0, 0, 0) scale3d(0.6, 0.6, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)", msTransform: "translate3d(0, 0, 0) scale3d(0.6, 0.6, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)", "transform": "translate3d(0, 0, 0) scale3d(0.6, 0.6, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)", "opacity": "0" }}
                alt="" className="community-spotlight-icon" /></div>
              <div
                style={{
                  opacity: 0,
                  WebkitTransform: "translate3d(0, 0, 0) scale3d(0.8, 0.8, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                  MozTransform: "translate3d(0, 0, 0) scale3d(0.8, 0.8, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                  msTransform: "translate3d(0, 0, 0) scale3d(0.8, 0.8, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                  transform: "translate3d(0, 0, 0) scale3d(0.8, 0.8, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)"
                }}
                className="community-spotlight-title-description">
                <h2 className="community-spotlight-title">The future of internet should be decentralized.</h2>
                <p className="community-spotlight-description">Create, Optimize, Dominate: AI for DigitalMarketing Success</p>
              </div><img src="/images/community-20spotlight-20shape.webp" loading="lazy" style={{ opacity: "0" }}
                sizes="(max-width: 536px) 100vw, 536px" alt=""
                srcSet="images/community-2520spotlight-2520shape-p-500.png 500w, images/community-20spotlight-20shape.webp 536w"
                className="community-spotlight-shape" />
            </div>
            <div data-w-id="7436af0c-4104-52c0-12c7-24cd299651ae" className="community-spotlight-image-wrap"><img
              src="/images/community-20spotlight-20bg.webp" loading="lazy" sizes="(max-width: 1437px) 100vw, 1437px"
              srcSet="images/community-20spotlight-20bg.webp 500w, images/community-20spotlight-20bg.webp 800w, images/community-20spotlight-20bg.webp 1080w, images/community-20spotlight-20bg.webp 1437w"
              alt="" className="community-spotlight-image-bg-shape" />
              <div className="community-spotlight-top-images"><img src="/images/community-20spotlight-20img1.webp"
                loading="lazy"
                style={{
                  WebkitTransform: "translate3d(0, -430px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                  MozTransform: "translate3d(0, -430px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                  msTransform: "translate3d(0, -430px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                  transform: "translate3d(0, -430px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                  opacity: 0
                }}
                alt="" className="community-spotlight-image _1" /><img src="/images/community-20spotlight-20img2.webp"
                  loading="lazy"
                  style={{
                    WebkitTransform: "translate3d(0, -420px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                    MozTransform: "translate3d(0, -420px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                    msTransform: "translate3d(0, -420px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                    transform: "translate3d(0, -420px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                    opacity: 0
                  }}
                  alt="" className="community-spotlight-image _2" /><img src="/images/community-20spotlight-20img3.webp"
                    loading="lazy"
                    style={{
                      WebkitTransform: "translate3d(0, -420px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                      MozTransform: "translate3d(0, -420px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                      msTransform: "translate3d(0, -420px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                      transform: "translate3d(0, -420px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                      opacity: 0
                    }}
                    alt="" className="community-spotlight-image _3" /><img src="/images/community-20spotlight-20img4.webp"
                      loading="lazy"
                      style={{
                        WebkitTransform: "translate3d(0, -420px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                        MozTransform: "translate3d(0, -420px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                        msTransform: "translate3d(0, -420px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                        transform: "translate3d(0, -420px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                        opacity: 0
                      }}
                      alt="" className="community-spotlight-image _4" /><img src="/images/community-20spotlight-20img5.webp"
                        loading="lazy"
                        style={{
                          WebkitTransform: "translate3d(0, -420px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                          MozTransform: "translate3d(0, -420px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                          msTransform: "translate3d(0, -420px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                          transform: "translate3d(0, -420px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                          opacity: 0
                        }}
                        alt="" className="community-spotlight-image _5" /><img src="/images/community-20spotlight-20img6.webp"
                          loading="lazy"
                          style={{
                            WebkitTransform: "translate3d(0, -420px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                            MozTransform: "translate3d(0, -420px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                            msTransform: "translate3d(0, -420px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                            transform: "translate3d(0, -420px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                            opacity: 0
                          }}
                          alt="" className="community-spotlight-image _6" /><img src="/images/community-20spotlight-20img7.webp"
                            loading="lazy"
                            style={{
                              WebkitTransform: "translate3d(0, -420px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                              MozTransform: "translate3d(0, -420px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                              msTransform: "translate3d(0, -420px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                              transform: "translate3d(0, -420px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                              opacity: 0
                            }}
                            alt="" className="community-spotlight-image _7" /></div>
              <div className="community-spotlight-bottom-images"><img src="/images/community-20spotlight-20image8.webp"
                loading="lazy"
                style={{
                  WebkitTransform: "translate3d(0, -400px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                  MozTransform: "translate3d(0, -400px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                  msTransform: "translate3d(0, -400px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                  transform: "translate3d(0, -400px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                  opacity: 0
                }}
                alt="" className="community-spotlight-image _8" /><img src="/images/community-20spotlight-20image9.webp"
                  loading="lazy"
                  style={{
                    WebkitTransform: "translate3d(0, -400px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                    MozTransform: "translate3d(0, -400px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                    msTransform: "translate3d(0, -400px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                    transform: "translate3d(0, -400px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                    opacity: 0
                  }}
                  alt="" className="community-spotlight-image _9" /><img src="/images/community-20spotlight-20image10.webp"
                    loading="lazy"
                    style={{
                      WebkitTransform: "translate3d(0, -400px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                      MozTransform: "translate3d(0, -400px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                      msTransform: "translate3d(0, -400px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                      transform: "translate3d(0, -400px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                      opacity: 0
                    }}
                    alt="" className="community-spotlight-image _10" /><img src="/images/community-20spotlight-20image11.webp"
                      loading="lazy"
                      style={{
                        WebkitTransform: "translate3d(0, -400px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                        MozTransform: "translate3d(0, -400px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                        msTransform: "translate3d(0, -400px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                        transform: "translate3d(0, -400px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                        opacity: 0
                      }}
                      alt="" className="community-spotlight-image _11" /><img src="/images/community-20spotlight-20image12.webp"
                        loading="lazy"
                        style={{
                          WebkitTransform: "translate3d(0, -400px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                          MozTransform: "translate3d(0, -400px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                          msTransform: "translate3d(0, -400px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                          transform: "translate3d(0, -400px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                          opacity: 0
                        }}
                        alt="" className="community-spotlight-image _12" /><img src="/images/community-20spotlight-20image13.webp"
                          loading="lazy"
                          style={{
                            WebkitTransform: "translate3d(0, -400px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                            MozTransform: "translate3d(0, -400px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                            msTransform: "translate3d(0, -400px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                            transform: "translate3d(0, -400px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                            opacity: 0
                          }}
                          alt="" className="community-spotlight-image _13" /><img src="/images/community-20spotlight-20image14.webp"
                            loading="lazy"
                            style={{
                              WebkitTransform: "translate3d(0, -400px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                              MozTransform: "translate3d(0, -400px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                              msTransform: "translate3d(0, -400px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                              transform: "translate3d(0, -400px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                              opacity: 0
                            }}
                            alt="" className="community-spotlight-image _14" /><img src="/images/community-20spotlight-20image15.webp"
                              loading="lazy"
                              style={{
                                WebkitTransform: "translate3d(0, -400px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                                MozTransform: "translate3d(0, -400px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                                msTransform: "translate3d(0, -400px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                                transform: "translate3d(0, -400px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                                opacity: 0
                              }}
                              alt="" className="community-spotlight-image _15" /><img src="/images/community-20spotlight-20image16.webp"
                                loading="lazy"
                                style={{
                                  WebkitTransform: "translate3d(0, -400px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                                  MozTransform: "translate3d(0, -400px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                                  msTransform: "translate3d(0, -400px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                                  transform: "translate3d(0, -400px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                                  opacity: 0
                                }}
                                alt="" className="community-spotlight-image _16" /><img src="/images/community-20spotlight-20image17.webp"
                                  loading="lazy"
                                  style={{
                                    WebkitTransform: "translate3d(0, -400px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                                    MozTransform: "translate3d(0, -400px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                                    msTransform: "translate3d(0, -400px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                                    transform: "translate3d(0, -400px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                                    opacity: 0
                                  }}
                                  alt="" className="community-spotlight-image _17" /><img src="/images/community-20spotlight-20image18.webp"
                                    loading="lazy"
                                    style={{
                                      WebkitTransform: "translate3d(0, -400px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                                      MozTransform: "translate3d(0, -400px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                                      msTransform: "translate3d(0, -400px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                                      transform: "translate3d(0, -400px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                                      opacity: 0
                                    }}
                                    alt="" className="community-spotlight-image _18" /></div>
            </div>
            <div className="community-spotlight-button-wrapper">
              <div className="primary-button-wrapper"><a href="/JoinNow" className="inner-button w-inline-block">
                <div className="primary-button-border-wrap">
                  <div className="inner-button-wrap">
                    <div className="inner-button-text-wrap">
                      <div className="inner-button-text">Join with community</div>
                      <div className="inner-button-hover-text">Join with community</div>
                    </div>
                    <div className="inner-button-star-wrap"><img loading="lazy" src="/images/inner-button-star-1.svg" alt=""
                      className="inner-button-star _1" /><img loading="lazy" src="/images/inner-button-star-2.svg" alt=""
                        className="inner-button-star _2" /><img loading="lazy" src="/images/inner-button-star-3.svg" alt=""
                          className="inner-button-star _3" /></div>
                    <div className="inner-button-hover-bg"></div>
                  </div>
                </div>
                <div className="line-wrap-inner">
                  <div className="inner-line-wrap _1">
                    <div className="line"></div>
                    <div className="line _2"></div>
                  </div>
                  <div className="inner-line-wrap _2">
                    <div className="line _3"></div>
                    <div className="line _4"></div>
                  </div>
                  <div className="inner-line-wrap _3">
                    <div className="line _5"></div>
                    <div className="line _6"></div>
                  </div>
                  <div className="inner-line-wrap _4">
                    <div className="line _7"></div>
                    <div className="line _8"></div>
                  </div>
                </div>
              </a></div>
            </div>
          </div>
        </section>
        <section className="section history">
          <div className="container">
            <div className="history-container">
              <div data-w-id="397f5323-a150-55eb-2c9a-bf44f92a9c08" className="history-wrapper">
                <div className="histories-flex-wrap">
                  <div className="single-history-wrap">
                    <div className="split-wrapper">
                      <div className="history-image-wrap"><img sizes="100vw"
                        srcset="images/history-img-1.webp 500w, images/history-img-1.webp 549w" alt=""
                        src="images/history-img-1.webp" loading="lazy" className="history-image" /></div>
                    </div>
                    <div className="split-wrapper">
                      <div data-w-id="397f5323-a150-55eb-2c9a-bf44f92a9c0f" style={{ "opacity": "0" }} className="history-content-wrap">
                        <div className="history-year">(2018)</div>
                        <div className="history-details-wrap">
                          <h2 className="history-title">Foundation</h2>
                          <p className="history-details">With digital transformation sweeping the fashion industry, We pioneers
                            the use of blockchain for greater transparency and security.</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="single-history-wrap reverse">
                    <div className="split-wrapper">
                      <div data-w-id="397f5323-a150-55eb-2c9a-bf44f92a9c19" style={{ "opacity": "0" }}
                        className="history-content-wrap align-right">
                        <div className="history-year">(2020)</div>
                        <div className="history-details-wrap">
                          <h2 className="history-title">Growing</h2>
                          <p className="history-details auto">With digital transformation sweeping the fashion industry, We
                            pioneers the use of blockchain for greater transparency and security.</p>
                        </div>
                      </div>
                    </div>
                    <div className="split-wrapper">
                      <div className="history-image-wrap"><img sizes="100vw"
                        srcset="images/history-img-2.webp 500w, images/history-img-2.webp 549w" alt=""
                        src="images/history-img-2.webp" loading="lazy" className="history-image" /></div>
                    </div>
                  </div>
                  <div className="single-history-wrap">
                    <div className="split-wrapper">
                      <div className="history-image-wrap"><img sizes="100vw"
                        srcset="images/history-img-3.webp 500w, images/history-img-3.webp 549w" alt=""
                        src="images/history-img-3.webp" loading="lazy" className="history-image" /></div>
                    </div>
                    <div className="split-wrapper">
                      <div data-w-id="397f5323-a150-55eb-2c9a-bf44f92a9c29" style={{ "opacity": "0" }} className="history-content-wrap">
                        <div className="history-year">(2022)</div>
                        <div className="history-details-wrap">
                          <h2 className="history-title">Achieve</h2>
                          <p className="history-details">With digital transformation sweeping the fashion industry, We pioneers
                            the use of blockchain for greater transparency and security.</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="history-divider-wrap">
                  <div className="history-star-wrap"><img loading="lazy" src="images/history-20star.svg" alt=""
                    className="history-star" /></div>
                  <div className="history-divider-line"></div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="section about-team-member">
          <div className="container">
            <div className="about-team-member-container">
              <div data-w-id="ae392023-fc09-8688-8e18-0dfbf76b2900" style={{ "opacity": "0" }} className="faq-section-title-wrapper">
                <div className="section-subtitle-wrapper">
                  <div className="section-subtitle">[ team member ]</div>
                </div>
                <div className="section-title-single">
                  <h2 className="section-title">Explore our talented experts.</h2>
                </div>
              </div>
              <div data-w-id="6c23f198-b2c2-6068-da6d-7539a5ef289d" style={{ "opacity": "0" }} className="about-team-member-content">
                <div className="about-team-member-top-content">
                  <div className="about-team-member-top-single"><img src="images/about-20team-20member-20line1.svg"
                    loading="lazy" alt="" className="about-team-member-line top-left" /><img
                      src="images/about-20team-20member-20line2.svg" loading="lazy" alt=""
                      className="about-team-member-line top-right" /><img src="images/about-20team-20member-20line3.svg"
                        loading="lazy" alt="" className="about-team-member-line bottom-left" /><img
                      src="images/about-20team-20member-20line4.svg" loading="lazy" alt=""
                      className="about-team-member-line bottom-right" />
                    <div className="about-team-member-name-bio">
                      <h4 className="about-team-member-name">Marvin McKinney</h4>
                      <div className="about-team-member-bio">CEO &amp; Chairman at, <span
                        className="about-team-member-bio-span">Zocor</span></div>
                    </div><img src="images/about-20team-20member-20image1.webp" loading="lazy" alt=""
                      className="about-team-member-image one" />
                    <div className="about-team-member-social-media-wrapper"><a href="https://www.instagram.com/" target="_blank"
                      className="about-team-member-social-single w-inline-block">
                      <div className="about-team-member-social-media-icon"></div>
                    </a><a href="https://twitter.com/" target="_blank"
                      className="about-team-member-social-single w-inline-block">
                        <div className="about-team-member-social-media-icon"></div>
                      </a><a href="https://linkedin.com/" target="_blank"
                        className="about-team-member-social-single w-inline-block">
                        <div className="about-team-member-social-media-icon"></div>
                      </a></div>
                  </div>
                  <div className="about-team-member-top-single"><img src="images/about-20team-20member-20line1.svg"
                    loading="lazy" alt="" className="about-team-member-line top-left" /><img
                      src="images/about-20team-20member-20line2.svg" loading="lazy" alt=""
                      className="about-team-member-line top-right" /><img src="images/about-20team-20member-20line3.svg"
                        loading="lazy" alt="" className="about-team-member-line bottom-left" /><img
                      src="images/about-20team-20member-20line4.svg" loading="lazy" alt=""
                      className="about-team-member-line bottom-right" />
                    <div className="about-team-member-name-bio">
                      <h4 className="about-team-member-name">Darrel Steward</h4>
                      <div className="about-team-member-bio">Managing director at, <span
                        className="about-team-member-bio-span">Zocor</span></div>
                    </div><img src="images/about-20team-20member-20image2.webp" loading="lazy" alt=""
                      className="about-team-member-image one" />
                    <div className="about-team-member-social-media-wrapper"><a href="https://www.instagram.com/" target="_blank"
                      className="about-team-member-social-single w-inline-block">
                      <div className="about-team-member-social-media-icon"></div>
                    </a><a href="https://twitter.com/" target="_blank"
                      className="about-team-member-social-single w-inline-block">
                        <div className="about-team-member-social-media-icon"></div>
                      </a><a href="https://linkedin.com/" target="_blank"
                        className="about-team-member-social-single w-inline-block">
                        <div className="about-team-member-social-media-icon"></div>
                      </a></div>
                  </div>
                </div>
                <div className="about-team-member-bottom-content">
                  <div className="w-layout-grid about-team-member-bottom-grid">
                    <div className="about-team-member-bottom-single">
                      <div className="about-team-single-member-img-wrap"><img
                        src="images/about-20team-20single-20member-20img1.webp" loading="lazy" alt=""
                        className="about-team-single-member-img" /></div>
                      <div className="about-team-member-bottom-name-bio">
                        <h5 className="about-team-member-bottom-name">William Joseph</h5>
                        <div className="about-team-member-bottom-bio">Product Designer</div>
                      </div>
                      <div className="about-team-member-bottom-social-media"><a href="https://www.instagram.com/"
                        target="_blank" className="about-team-member-bottom-social-link w-inline-block">
                        <div></div>
                      </a><a href="https://twitter.com/" target="_blank"
                        className="about-team-member-bottom-social-link w-inline-block">
                          <div></div>
                        </a><a href="https://linkedin.com/" target="_blank"
                          className="about-team-member-bottom-social-link w-inline-block">
                          <div></div>
                        </a></div><img src="images/features-20card-20shape-20top-20left.svg" loading="lazy" alt=""
                          className="about-team-member-line top-left" /><img
                        src="images/features-20card-20shape-20top-20right.svg" loading="lazy" alt=""
                        className="about-team-member-line top-right" /><img
                        src="images/features-20card-20shape-20bottom-20left.svg" loading="lazy" alt=""
                        className="about-team-member-line bottom-left" /><img
                        src="images/features-20card-20shape-20bottom-20right.svg" loading="lazy" alt=""
                        className="about-team-member-line bottom-right" />
                    </div>
                    <div className="about-team-member-bottom-single">
                      <div className="about-team-single-member-img-wrap"><img
                        src="images/about-20team-20single-20member-20img2.webp" loading="lazy" alt=""
                        className="about-team-single-member-img" /></div>
                      <div className="about-team-member-bottom-name-bio">
                        <h5 className="about-team-member-bottom-name">Charlotte Rose</h5>
                        <div className="about-team-member-bottom-bio">Product Designer</div>
                      </div>
                      <div className="about-team-member-bottom-social-media"><a href="https://www.instagram.com/"
                        target="_blank" className="about-team-member-bottom-social-link w-inline-block">
                        <div></div>
                      </a><a href="https://twitter.com/" target="_blank"
                        className="about-team-member-bottom-social-link w-inline-block">
                          <div></div>
                        </a><a href="https://linkedin.com/" target="_blank"
                          className="about-team-member-bottom-social-link w-inline-block">
                          <div></div>
                        </a></div><img src="images/features-20card-20shape-20top-20left.svg" loading="lazy" alt=""
                          className="about-team-member-line top-left" /><img
                        src="images/features-20card-20shape-20top-20right.svg" loading="lazy" alt=""
                        className="about-team-member-line top-right" /><img
                        src="images/features-20card-20shape-20bottom-20left.svg" loading="lazy" alt=""
                        className="about-team-member-line bottom-left" /><img
                        src="images/features-20card-20shape-20bottom-20right.svg" loading="lazy" alt=""
                        className="about-team-member-line bottom-right" />
                    </div>
                    <div className="about-team-member-bottom-single">
                      <div className="about-team-single-member-img-wrap"><img
                        src="images/about-20team-20single-20member-20img3.webp" loading="lazy" alt=""
                        className="about-team-single-member-img" /></div>
                      <div className="about-team-member-bottom-name-bio">
                        <h5 className="about-team-member-bottom-name">Michael James</h5>
                        <div className="about-team-member-bottom-bio">Marketing Leader</div>
                      </div>
                      <div className="about-team-member-bottom-social-media"><a href="https://www.instagram.com/"
                        target="_blank" className="about-team-member-bottom-social-link w-inline-block">
                        <div></div>
                      </a><a href="https://twitter.com/" target="_blank"
                        className="about-team-member-bottom-social-link w-inline-block">
                          <div></div>
                        </a><a href="https://linkedin.com/" target="_blank"
                          className="about-team-member-bottom-social-link w-inline-block">
                          <div></div>
                        </a></div><img src="images/features-20card-20shape-20top-20left.svg" loading="lazy" alt=""
                          className="about-team-member-line top-left" /><img
                        src="images/features-20card-20shape-20top-20right.svg" loading="lazy" alt=""
                        className="about-team-member-line top-right" /><img
                        src="images/features-20card-20shape-20bottom-20left.svg" loading="lazy" alt=""
                        className="about-team-member-line bottom-left" /><img
                        src="images/features-20card-20shape-20bottom-20right.svg" loading="lazy" alt=""
                        className="about-team-member-line bottom-right" />
                    </div>
                    <div className="about-team-member-bottom-single">
                      <div className="about-team-single-member-img-wrap"><img
                        src="images/about-20team-20single-20member-20img4.webp" loading="lazy" alt=""
                        className="about-team-single-member-img" /></div>
                      <div className="about-team-member-bottom-name-bio">
                        <h5 className="about-team-member-bottom-name">Jennifer Ann</h5>
                        <div className="about-team-member-bottom-bio">Project Manager</div>
                      </div>
                      <div className="about-team-member-bottom-social-media"><a href="https://www.instagram.com/"
                        target="_blank" className="about-team-member-bottom-social-link w-inline-block">
                        <div></div>
                      </a><a href="https://twitter.com/" target="_blank"
                        className="about-team-member-bottom-social-link w-inline-block">
                          <div></div>
                        </a><a href="https://linkedin.com/" target="_blank"
                          className="about-team-member-bottom-social-link w-inline-block">
                          <div></div>
                        </a></div><img src="images/features-20card-20shape-20top-20left.svg" loading="lazy" alt=""
                          className="about-team-member-line top-left" /><img
                        src="images/features-20card-20shape-20top-20right.svg" loading="lazy" alt=""
                        className="about-team-member-line top-right" /><img
                        src="images/features-20card-20shape-20bottom-20left.svg" loading="lazy" alt=""
                        className="about-team-member-line bottom-left" /><img
                        src="images/features-20card-20shape-20bottom-20right.svg" loading="lazy" alt=""
                        className="about-team-member-line bottom-right" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="section faq padding-bottom0">
          <div className="container">
            <div data-w-id="43b38857-68be-2b7e-8fb7-72677ece56f6" style={{ "opacity": "0" }} className="faq-section-title-wrapper">
              <div className="section-subtitle-wrapper">
                <div className="section-subtitle">[ Solving ]</div>
              </div>
              <div className="section-title-single">
                <h2 className="section-title">Frequently asked questions</h2>
              </div>
            </div>
            <div data-w-id="43b38857-68be-2b7e-8fb7-72677ece56fd" style={{ "opacity": "0" }} className="faq-content">
              <div data-current="Tab 1" data-easing="ease" data-duration-in="300" data-duration-out="100" className="w-tabs">
                <div className="faq-accordion-wrapper w-tab-menu"><a data-w-tab="Tab 1"
                  className="single-faq-accordion-wrap w-inline-block w-tab-link w--current">
                  <div className="faq-accordion-question-wrap">
                    <h3 className="faq-question">What is Blockchain and how does it work?</h3>
                    <div className="faq-icon-wrapper"><img loading="lazy" src="images/faq-20icon.svg" alt=""
                      className="faq-icon" /><img src="images/faq-20icon-20shape.svg" loading="lazy" alt=""
                        className="faq-icon-shape" /></div>
                  </div>
                  <div className="faq-accordion-answer-wrap">
                    <div className="faq-answer">
                      <p className="faq-answer-text">Blockchain is a decentralized, distributed ledger technology that records
                        transactions securely and transparently. It works by storing data in blocks that are linked
                        together in a chain, making it tamper-proof and immutable.</p>
                    </div>
                  </div><img src="images/features-20card-20shape-20top-20left.svg" loading="lazy" alt=""
                    className="single-faq-accordion-line top-left" /><img
                    src="images/features-20card-20shape-20top-20right.svg" loading="lazy" alt=""
                    className="single-faq-accordion-line top-right" /><img
                    src="images/features-20card-20shape-20bottom-20left.svg" loading="lazy" alt=""
                    className="single-faq-accordion-line bottom-left" /><img
                    src="images/features-20card-20shape-20bottom-20right.svg" loading="lazy" alt=""
                    className="single-faq-accordion-line bottom-right" />
                </a><a data-w-tab="Tab 2" className="single-faq-accordion-wrap w-inline-block w-tab-link">
                    <div className="faq-accordion-question-wrap">
                      <h3 className="faq-question">What is Web3 and how is it different from Web2?</h3>
                      <div className="faq-icon-wrapper"><img loading="lazy" src="images/faq-20icon.svg" alt=""
                        className="faq-icon" /><img src="images/faq-20icon-20shape.svg" loading="lazy" alt=""
                          className="faq-icon-shape" /></div>
                    </div>
                    <div className="faq-accordion-answer-wrap">
                      <div className="faq-answer">
                        <p className="faq-answer-text">Blockchain is a decentralized, distributed ledger technology that records
                          transactions securely and transparently. It works by storing data in blocks that are linked
                          together in a chain, making it tamper-proof and immutable.</p>
                      </div>
                    </div><img src="images/features-20card-20shape-20top-20left.svg" loading="lazy" alt=""
                      className="single-faq-accordion-line top-left" /><img
                      src="images/features-20card-20shape-20top-20right.svg" loading="lazy" alt=""
                      className="single-faq-accordion-line top-right" /><img
                      src="images/features-20card-20shape-20bottom-20left.svg" loading="lazy" alt=""
                      className="single-faq-accordion-line bottom-left" /><img
                      src="images/features-20card-20shape-20bottom-20right.svg" loading="lazy" alt=""
                      className="single-faq-accordion-line bottom-right" />
                  </a><a data-w-tab="Tab 3" className="single-faq-accordion-wrap w-inline-block w-tab-link">
                    <div className="faq-accordion-question-wrap">
                      <h3 className="faq-question">What are Smart Contracts?</h3>
                      <div className="faq-icon-wrapper"><img loading="lazy" src="images/faq-20icon.svg" alt=""
                        className="faq-icon" /><img src="images/faq-20icon-20shape.svg" loading="lazy" alt=""
                          className="faq-icon-shape" /></div>
                    </div>
                    <div className="faq-accordion-answer-wrap">
                      <div className="faq-answer">
                        <p className="faq-answer-text">Blockchain is a decentralized, distributed ledger technology that records
                          transactions securely and transparently. It works by storing data in blocks that are linked
                          together in a chain, making it tamper-proof and immutable.</p>
                      </div>
                    </div><img src="images/features-20card-20shape-20top-20left.svg" loading="lazy" alt=""
                      className="single-faq-accordion-line top-left" /><img
                      src="images/features-20card-20shape-20top-20right.svg" loading="lazy" alt=""
                      className="single-faq-accordion-line top-right" /><img
                      src="images/features-20card-20shape-20bottom-20left.svg" loading="lazy" alt=""
                      className="single-faq-accordion-line bottom-left" /><img
                      src="images/features-20card-20shape-20bottom-20right.svg" loading="lazy" alt=""
                      className="single-faq-accordion-line bottom-right" />
                  </a><a data-w-tab="Tab 4" className="single-faq-accordion-wrap w-inline-block w-tab-link">
                    <div className="faq-accordion-question-wrap">
                      <h3 className="faq-question">What is DeFi (Decentralized Finance)?</h3>
                      <div className="faq-icon-wrapper"><img loading="lazy" src="images/faq-20icon.svg" alt=""
                        className="faq-icon" /><img src="images/faq-20icon-20shape.svg" loading="lazy" alt=""
                          className="faq-icon-shape" /></div>
                    </div>
                    <div className="faq-accordion-answer-wrap">
                      <div className="faq-answer">
                        <p className="faq-answer-text">Blockchain is a decentralized, distributed ledger technology that records
                          transactions securely and transparently. It works by storing data in blocks that are linked
                          together in a chain, making it tamper-proof and immutable.</p>
                      </div>
                    </div><img src="images/features-20card-20shape-20top-20left.svg" loading="lazy" alt=""
                      className="single-faq-accordion-line top-left" /><img
                      src="images/features-20card-20shape-20top-20right.svg" loading="lazy" alt=""
                      className="single-faq-accordion-line top-right" /><img
                      src="images/features-20card-20shape-20bottom-20left.svg" loading="lazy" alt=""
                      className="single-faq-accordion-line bottom-left" /><img
                      src="images/features-20card-20shape-20bottom-20right.svg" loading="lazy" alt=""
                      className="single-faq-accordion-line bottom-right" />
                  </a><a data-w-tab="Tab 5" className="single-faq-accordion-wrap w-inline-block w-tab-link">
                    <div className="faq-accordion-question-wrap">
                      <h3 className="faq-question">How does Blockchain improve security?</h3>
                      <div className="faq-icon-wrapper"><img loading="lazy" src="images/faq-20icon.svg" alt=""
                        className="faq-icon" /><img src="images/faq-20icon-20shape.svg" loading="lazy" alt=""
                          className="faq-icon-shape" /></div>
                    </div>
                    <div className="faq-accordion-answer-wrap">
                      <div className="faq-answer">
                        <p className="faq-answer-text">Blockchain is a decentralized, distributed ledger technology that records
                          transactions securely and transparently. It works by storing data in blocks that are linked
                          together in a chain, making it tamper-proof and immutable.</p>
                      </div>
                    </div><img src="images/features-20card-20shape-20top-20left.svg" loading="lazy" alt=""
                      className="single-faq-accordion-line top-left" /><img
                      src="images/features-20card-20shape-20top-20right.svg" loading="lazy" alt=""
                      className="single-faq-accordion-line top-right" /><img
                      src="images/features-20card-20shape-20bottom-20left.svg" loading="lazy" alt=""
                      className="single-faq-accordion-line bottom-left" /><img
                      src="images/features-20card-20shape-20bottom-20right.svg" loading="lazy" alt=""
                      className="single-faq-accordion-line bottom-right" />
                  </a></div>
                <div className="display-none w-tab-content">
                  <div data-w-tab="Tab 1" className="w-tab-pane w--tab-active"></div>
                  <div data-w-tab="Tab 2" className="w-tab-pane"></div>
                  <div data-w-tab="Tab 3" className="w-tab-pane"></div>
                  <div data-w-tab="Tab 4" className="w-tab-pane"></div>
                  <div data-w-tab="Tab 5" className="w-tab-pane"></div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section data-w-id="1c3f6ead-2444-a223-fec9-b2e0c543d72e" className="section cta">
          <div className="container">
            <div className="cta-content">
              <div data-w-id="1c3f6ead-2444-a223-fec9-b2e0c543d731" className="cta-typography">
                <div className="cta-title-description">
                  <h2 className="cta-title">Embrace the future of Web3 and Blockchain.</h2>
                  <p className="cta-description-text">Highly scalable, fast and secure blockchain platform for distributed apps,
                    enterprise use cases.</p>
                </div>
                <div className="cta-button-wrapper">
                  <div className="primary-button-wrapper"><a href="/pricing" className="inner-button w-inline-block">
                    <div className="primary-button-border-wrap">
                      <div className="inner-button-wrap">
                        <div className="inner-button-text-wrap">
                          <div className="inner-button-text">Get started now</div>
                          <div className="inner-button-hover-text">Get started now</div>
                        </div>
                        <div className="inner-button-star-wrap"><img loading="lazy" src="images/inner-button-star-1.svg"
                          alt="" className="inner-button-star _1" /><img loading="lazy" src="images/inner-button-star-2.svg"
                            alt="" className="inner-button-star _2" /><img loading="lazy" src="images/inner-button-star-3.svg"
                              alt="" className="inner-button-star _3" /></div>
                        <div className="inner-button-hover-bg"></div>
                      </div>
                    </div>
                    <div className="line-wrap-inner">
                      <div className="inner-line-wrap _1">
                        <div className="line"></div>
                        <div className="line _2"></div>
                      </div>
                      <div className="inner-line-wrap _2">
                        <div className="line _3"></div>
                        <div className="line _4"></div>
                      </div>
                      <div className="inner-line-wrap _3">
                        <div className="line _5"></div>
                        <div className="line _6"></div>
                      </div>
                      <div className="inner-line-wrap _4">
                        <div className="line _7"></div>
                        <div className="line _8"></div>
                      </div>
                    </div>
                  </a></div>
                </div>
              </div><img src="images/features-20card-20shape-20top-20left.svg" loading="lazy" alt=""
                className="cta-top-left-element" /><img src="images/features-20card-20shape-20top-20right.svg" loading="lazy"
                  alt="" className="cta-top-right-element" /><img src="images/cta-20botton-20left-20element.svg" loading="lazy"
                    alt="" className="cta-bottom-left-element" /><img src="images/cta-20botton-20right-20element.svg" loading="lazy"
                      alt="" className="cta-bottom-right-element" /><img src="images/cta-20shape.webp" loading="lazy"
                        data-w-id="1c3f6ead-2444-a223-fec9-b2e0c543d752" sizes="(max-width: 537px) 100vw, 537px" alt=""
                        srcset="images/cta-2520shape-p-500.png 500w, images/cta-20shape.webp 537w" className="cta-shape" /><img
                src="images/cta-20elment1.webp" loading="lazy" data-w-id="1c3f6ead-2444-a223-fec9-b2e0c543d753" alt=""
                className="cta-elment-one" /><img src="images/cta-20elment2.webp" loading="lazy"
                  data-w-id="1c3f6ead-2444-a223-fec9-b2e0c543d754" alt="" className="cta-elment-two" />
            </div>
          </div>
        </section>
        <Footer />
      </div>
    </>
  )

};

export default About; 